import React, { useState, useEffect, useRef } from 'react';
import { useDrawer } from '../../context/DrawerContext';

// ── Icon ──────────────────────────────────────────────────────
export const Icon = ({ name, size = 18, stroke = 1.6, style }) => {
  const paths = {
    menu:        <><path d="M2 5h14M2 9h14M2 13h14"/></>,
    close:       <><path d="M3 3l12 12M15 3L3 15"/></>,
    search:      <><circle cx="8" cy="8" r="5"/><path d="M12 12l4 4"/></>,
    bell:        <><path d="M4 13h10l-1-2V8a4 4 0 10-8 0v3l-1 2z"/><path d="M7 15a2 2 0 004 0"/></>,
    home:        <><path d="M3 8l6-5 6 5v7a1 1 0 01-1 1h-3v-5H7v5H4a1 1 0 01-1-1V8z"/></>,
    calendar:    <><rect x="2.5" y="3.5" width="13" height="12" rx="2"/><path d="M2.5 7h13M6 2v3M12 2v3"/></>,
    book:        <><path d="M3 3h6a3 3 0 013 3v10a2 2 0 00-2-2H3V3z"/><path d="M15 3H9a3 3 0 00-3 3v10a2 2 0 012-2h7V3z"/></>,
    user:        <><circle cx="9" cy="6.5" r="3"/><path d="M3 16c1-3 3.5-4.5 6-4.5s5 1.5 6 4.5"/></>,
    users:       <><circle cx="7" cy="6" r="2.5"/><path d="M2 15c.7-2.2 2.6-3.5 5-3.5s4.3 1.3 5 3.5"/><circle cx="13" cy="5" r="2"/><path d="M12 11c1.8.1 3.2 1 4 2.5"/></>,
    'user-check':<><circle cx="7" cy="6" r="3"/><path d="M2 16c.7-2.5 2.7-4 5-4s4.3 1.5 5 4"/><path d="M12 9l1.5 1.5L17 7"/></>,
    payment:     <><rect x="2" y="5" width="14" height="10" rx="1.5"/><path d="M2 8h14M5 12h3"/></>,
    chart:       <><path d="M3 15V8M9 15V3M15 15v-5"/></>,
    clock:       <><circle cx="9" cy="9" r="6.5"/><path d="M9 5v4l3 2"/></>,
    logout:      <><path d="M11 3H4v12h7"/><path d="M9 9h7M13 6l3 3-3 3"/></>,
    plus:        <><path d="M9 3v12M3 9h12"/></>,
    chevron:        <><path d="M6 4l5 5-5 5"/></>,
    'chevron-right': <><path d="M6 4l5 5-5 5"/></>,
    'chevron-left':  <><path d="M12 4L7 9l5 5"/></>,
    chevronDown:    <><path d="M4 6l5 5 5-5"/></>,
    check:       <><path d="M3 9l4 4 8-8"/></>,
    arrow:       <><path d="M3 9h12M11 5l4 4-4 4"/></>,
    sparkle:     <><path d="M9 2v5M9 11v5M2 9h5M11 9h5"/></>,
    dot:         <><circle cx="9" cy="9" r="2.5" fill="currentColor"/></>,
    flame:       <><path d="M9 2c1 2 4 3 4 7a4 4 0 11-8 0c0-2 1-3 2-4 0 1 1 2 2 2 0-2-1-3 0-5z"/></>,
    cam:         <><rect x="2" y="5" width="11" height="9" rx="1.5"/><path d="M13 8l3-2v7l-3-2"/></>,
    pin:         <><path d="M9 17v-5"/><path d="M5 9V3h8v6l2 3H3l2-3z"/></>,
    edit:        <><path d="M3 13l9-9 3 3-9 9H3v-3z"/></>,
    download:    <><path d="M9 3v8M5 8l4 4 4-4M3 15h12"/></>,
    money:       <><circle cx="9" cy="9" r="6"/><path d="M9 5v8M11 7H8a1.5 1.5 0 000 3h2a1.5 1.5 0 010 3H7"/></>,
    location:    <><path d="M9 17s5-5 5-9a5 5 0 10-10 0c0 4 5 9 5 9z"/><circle cx="9" cy="8" r="1.8"/></>,
    phone:       <><path d="M4 3h3l2 4-2 1a8 8 0 004 4l1-2 4 2v3a1 1 0 01-1 1A13 13 0 013 4a1 1 0 011-1z"/></>,
    mail:        <><rect x="2" y="4" width="14" height="10" rx="1.5"/><path d="M2.5 5l6.5 5 6.5-5"/></>,
    settings:    <><circle cx="9" cy="9" r="2.5"/><path d="M9 2v2M9 14v2M2 9h2M14 9h2M4 4l1.5 1.5M12.5 12.5L14 14M4 14l1.5-1.5M12.5 5.5L14 4"/></>,
    star:        <><path d="M9 2l2 4.5 5 .5-3.5 3.5 1 5L9 13l-4.5 2.5 1-5L2 7l5-.5z"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" stroke="currentColor"
      strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" style={style}>
      {paths[name] || null}
    </svg>
  );
};

// ── MemaLogo ──────────────────────────────────────────────────
export const MemaLogo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={{ flexShrink: 0 }}>
    <g>
      <circle cx="36" cy="9" r="2.2" fill="#3eb8b1"/>
      <circle cx="41" cy="14" r="1.3" fill="#3eb8b1"/>
      <circle cx="32" cy="14" r="1.3" fill="#3eb8b1"/>
      <path d="M34 11l-2 2M38 11l3 2" stroke="#3eb8b1" strokeWidth="1.1" strokeLinecap="round"/>
    </g>
    <text x="8" y="25" fontFamily="Geist, system-ui" fontWeight="800" fontSize="18" fill="#3a1854" letterSpacing="-1">Me</text>
    <text x="8" y="42" fontFamily="Geist, system-ui" fontWeight="800" fontSize="18" fill="#3a1854" letterSpacing="-1">ma</text>
    <text x="29" y="22" fontFamily="Geist, system-ui" fontWeight="700" fontSize="7" fill="#3eb8b1">A+</text>
  </svg>
);

// ── Surface ───────────────────────────────────────────────────
export function Surface({ children, style, padded = false, elevated = false, ...rest }) {
  return (
    <div style={{
      background: elevated ? 'var(--bg-elevated)' : 'var(--bg-surface)',
      border: '1px solid var(--border-hairline)',
      borderRadius: 'var(--radius-lg)',
      padding: padded ? 'var(--pad-card)' : 0,
      boxShadow: elevated ? 'var(--shadow-md)' : 'var(--shadow-sm)',
      ...style,
    }} {...rest}>{children}</div>
  );
}

// ── Button ────────────────────────────────────────────────────
export function Button({ children, variant = 'primary', size = 'md', icon, iconRight, onClick, style, disabled }) {
  const styles = {
    primary:   { background: 'var(--accent)', color: 'var(--accent-fg)', border: '1px solid var(--accent)' },
    secondary: { background: 'var(--bg-surface)', color: 'var(--text-primary)', border: '1px solid var(--border-default)' },
    ghost:     { background: 'transparent', color: 'var(--text-primary)', border: '1px solid transparent' },
    soft:      { background: 'var(--accent-soft)', color: 'var(--accent)', border: '1px solid transparent' },
    danger:    { background: 'transparent', color: 'var(--danger)', border: '1px solid var(--border-default)' },
  };
  const sizes = {
    sm: { height: 28, padding: '0 10px', fontSize: 12.5, gap: 5, radius: 'var(--radius-sm)' },
    md: { height: 36, padding: '0 14px', fontSize: 13.5, gap: 6, radius: 'var(--radius-md)' },
    lg: { height: 44, padding: '0 18px', fontSize: 14.5, gap: 8, radius: 'var(--radius-md)' },
  };
  const s = sizes[size];
  return (
    <button onClick={onClick} disabled={disabled} style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: s.gap,
      height: s.height, padding: s.padding, fontSize: s.fontSize, fontWeight: 540,
      borderRadius: s.radius, cursor: disabled ? 'not-allowed' : 'pointer',
      fontFamily: 'inherit', letterSpacing: -0.1, whiteSpace: 'nowrap',
      transition: 'transform .12s, background .12s',
      opacity: disabled ? 0.5 : 1,
      ...styles[variant], ...style,
    }}>
      {icon && <Icon name={icon} size={size === 'sm' ? 14 : 16}/>}
      {children}
      {iconRight && <Icon name={iconRight} size={size === 'sm' ? 14 : 16}/>}
    </button>
  );
}

// ── IconButton ────────────────────────────────────────────────
export function IconButton({ icon, onClick, size = 36, variant = 'ghost', style, label, disabled, className }) {
  const variants = {
    ghost:   { background: 'transparent', color: 'var(--text-secondary)', border: 'none' },
    surface: { background: 'var(--bg-surface)', color: 'var(--text-primary)', border: '1px solid var(--border-default)' },
    soft:    { background: 'var(--accent-soft)', color: 'var(--accent)', border: 'none' },
    accent:  { background: 'var(--accent)', color: 'var(--accent-fg)', border: 'none' },
  };
  return (
    <button onClick={onClick} aria-label={label} disabled={disabled} className={className} style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: size, height: size, borderRadius: 'var(--radius-md)',
      cursor: disabled ? 'default' : 'pointer', fontFamily: 'inherit',
      transition: 'background .12s, transform .12s',
      flexShrink: 0, opacity: disabled ? 0.35 : 1,
      ...variants[variant], ...style,
    }}>
      <Icon name={icon} size={size >= 40 ? 18 : 16}/>
    </button>
  );
}

// ── Badge ─────────────────────────────────────────────────────
export function Badge({ children, tone = 'neutral', style }) {
  const tones = {
    neutral: { bg: 'var(--bg-sunken)', fg: 'var(--text-secondary)' },
    accent:  { bg: 'var(--accent-soft)', fg: 'var(--accent)' },
    success: { bg: 'color-mix(in oklch, var(--success) 14%, transparent)', fg: 'var(--success)' },
    warn:    { bg: 'color-mix(in oklch, var(--warn) 16%, transparent)', fg: 'var(--warn)' },
    danger:  { bg: 'color-mix(in oklch, var(--danger) 14%, transparent)', fg: 'var(--danger)' },
  };
  const t = tones[tone] || tones.neutral;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      height: 20, padding: '0 7px',
      borderRadius: 6, background: t.bg, color: t.fg,
      fontSize: 10.5, fontWeight: 600, letterSpacing: 0.2, textTransform: 'uppercase',
      fontFamily: 'inherit', whiteSpace: 'nowrap',
      ...style,
    }}>{children}</span>
  );
}

// ── Avatar ────────────────────────────────────────────────────
export function Avatar({ name, src, size = 36, ring = false }) {
  const initials = (name || '?').split(' ').slice(0, 2).map(s => s[0]).join('').toUpperCase();
  let hue = 0;
  for (let i = 0; i < (name || '').length; i++) hue = (hue * 31 + (name || '').charCodeAt(i)) % 360;
  const bg = `oklch(72% 0.08 ${hue})`;
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: src ? `url(${src}) center/cover no-repeat` : bg,
      color: '#fff', fontSize: size * 0.36, fontWeight: 600,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexShrink: 0, letterSpacing: -0.5,
      boxShadow: ring ? '0 0 0 2px var(--bg-surface), 0 0 0 3.5px var(--accent)' : 'none',
    }}>{!src && initials}</div>
  );
}

// ── Kbd ───────────────────────────────────────────────────────
export function Kbd({ children }) {
  return (
    <kbd style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      minWidth: 18, height: 18, padding: '0 4px',
      background: 'var(--bg-sunken)', color: 'var(--text-secondary)',
      border: '1px solid var(--border-hairline)',
      borderRadius: 4, fontSize: 10.5, fontWeight: 600,
      fontFamily: '"Geist Mono", ui-monospace, monospace',
    }}>{children}</kbd>
  );
}

// ── Divider ───────────────────────────────────────────────────
export function Divider({ vertical = false, style }) {
  return <div style={{
    background: 'var(--border-hairline)',
    ...(vertical ? { width: 1, alignSelf: 'stretch' } : { height: 1, width: '100%' }),
    ...style,
  }}/>;
}

// ── Stat ──────────────────────────────────────────────────────
export function Stat({ value, unit, label, delta }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <div style={{ fontSize: 10.5, fontWeight: 600, letterSpacing: 0.4, textTransform: 'uppercase', color: 'var(--text-tertiary)' }}>{label}</div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
        <span style={{
          fontFamily: '"Geist Mono", ui-monospace, monospace',
          fontSize: 20, fontWeight: 500, letterSpacing: -0.6,
          color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums',
        }}>{value}</span>
        {unit && <span style={{ fontSize: 11, color: 'var(--text-tertiary)' }}>{unit}</span>}
      </div>
      {delta && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 11, fontWeight: 540,
          color: delta.startsWith('-') ? 'var(--danger)' : 'var(--success)' }}>
          <span>{delta.startsWith('-') ? '↓' : '↑'}</span>{delta.replace(/^[-+]/, '')}
        </div>
      )}
    </div>
  );
}

// ── BottomSheet ───────────────────────────────────────────────
export function BottomSheet({ title, onClose, children }) {
  return (
    <div className="mema-bs-overlay" style={{
      position: 'fixed', inset: 0, zIndex: 300,
      display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
      background: 'rgba(0,0,0,0.35)', backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)',
    }} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="mema-bs-panel mema-scroll" style={{
        width: '100%', maxWidth: 480,
        background: 'var(--bg-surface)',
        borderRadius: 'var(--radius-xl) var(--radius-xl) 0 0',
        boxShadow: 'var(--shadow-lg)',
        animation: 'fadeSlideUp .25s cubic-bezier(.22,1,.36,1)',
        maxHeight: '92dvh', overflowY: 'auto', overscrollBehavior: 'contain',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: 'var(--gap-3)',
          borderBottom: '1px solid var(--border-hairline)',
          position: 'sticky', top: 0, background: 'var(--bg-surface)', zIndex: 1,
        }}>
          <div style={{ fontSize: 16, fontWeight: 600, letterSpacing: -0.3 }}>{title}</div>
          <IconButton icon="close" onClick={onClose} variant="ghost"/>
        </div>
        <div style={{ padding: 'var(--gap-3)' }}>{children}</div>
      </div>
    </div>
  );
}

// ── Dialog (modal centralizado — para formulários longos) ─────
export function Dialog({ title, onClose, children }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 300,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
      background: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)',
    }} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="mema-scroll" style={{
        width: '100%', maxWidth: 480,
        background: 'var(--bg-surface)',
        borderRadius: 'var(--radius-xl)',
        boxShadow: 'var(--shadow-lg)',
        animation: 'fadeSlideUp .2s cubic-bezier(.22,1,.36,1)',
        maxHeight: '92dvh', overflowY: 'auto', overscrollBehavior: 'contain',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: 'var(--gap-3)',
          borderBottom: '1px solid var(--border-hairline)',
          position: 'sticky', top: 0, background: 'var(--bg-surface)', zIndex: 1,
          borderRadius: 'var(--radius-xl) var(--radius-xl) 0 0',
        }}>
          <div style={{ fontSize: 16, fontWeight: 600, letterSpacing: -0.3 }}>{title}</div>
          <IconButton icon="close" onClick={onClose} variant="ghost"/>
        </div>
        <div style={{ padding: 'var(--gap-3)' }}>{children}</div>
      </div>
    </div>
  );
}

// ── FormField ─────────────────────────────────────────────────
export const inputCss = {
  height: 40, padding: '0 12px', fontSize: 16, width: '100%',
  background: 'var(--bg-sunken)', color: 'var(--text-primary)',
  border: '1px solid var(--border-default)', borderRadius: 'var(--radius-md)',
  fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box',
};

export function FormField({ label, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <label style={{ fontSize: 12, fontWeight: 540, color: 'var(--text-secondary)' }}>{label}</label>
      {children}
    </div>
  );
}

// ── FeedbackMsg ───────────────────────────────────────────────
export function FeedbackMsg({ msg }) {
  if (!msg) return null;
  const isError = msg.toLowerCase().includes('erro') || msg.toLowerCase().includes('falha') || msg.toLowerCase().includes('preencha') || msg.toLowerCase().includes('selecione');
  return (
    <div style={{
      fontSize: 13, padding: '8px 12px', borderRadius: 'var(--radius-sm)',
      background: isError ? 'color-mix(in oklch, var(--danger) 10%, transparent)' : 'color-mix(in oklch, var(--success) 10%, transparent)',
      color: isError ? 'var(--danger)' : 'var(--success)',
    }}>{msg}</div>
  );
}

// ── AlunoSearch ───────────────────────────────────────────────
export function AlunoSearch({ alunos = [], value, onChange, placeholder = 'Buscar aluno…' }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);

  const sorted = [...alunos].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));

  useEffect(() => {
    if (!value) { setQuery(''); return; }
    const found = sorted.find(a => String(a.id) === String(value));
    if (found) setQuery(found.nome);
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = query.length >= 2
    ? sorted.filter(a => a.nome.toLowerCase().includes(query.toLowerCase()))
    : [];

  function handleSelect(a) {
    setQuery(a.nome);
    onChange(String(a.id));
    setOpen(false);
  }

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)', pointerEvents: 'none' }}>
          <Icon name="search" size={14}/>
        </div>
        <input
          type="text"
          value={query}
          onChange={e => { setQuery(e.target.value); onChange(''); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 150)}
          placeholder={placeholder}
          autoComplete="off"
          style={{ ...inputCss, paddingLeft: 34, paddingRight: value ? 32 : 12 }}
        />
        {value && (
          <button type="button"
            onMouseDown={e => { e.preventDefault(); setQuery(''); onChange(''); }}
            style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-tertiary)', display: 'flex', padding: 2 }}>
            <Icon name="close" size={13}/>
          </button>
        )}
      </div>
      {open && filtered.length > 0 && (
        <div style={{
          position: 'absolute', left: 0, right: 0, top: 'calc(100% + 4px)',
          background: 'var(--bg-surface)', border: '1px solid var(--border-default)',
          borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-md)',
          zIndex: 200, maxHeight: 220, overflow: 'auto',
        }} className="mema-scroll">
          {filtered.map((a, i) => (
            <button key={a.id} type="button" onMouseDown={() => handleSelect(a)} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              width: '100%', padding: '10px 12px',
              background: 'transparent', border: 'none', cursor: 'pointer',
              textAlign: 'left', fontFamily: 'inherit',
              borderBottom: i < filtered.length - 1 ? '1px solid var(--border-hairline)' : 'none',
            }}>
              <Avatar name={a.nome} size={28}/>
              <span style={{ fontSize: 14, color: 'var(--text-primary)', letterSpacing: -0.1 }}>{a.nome}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// ── ScreenHeader ──────────────────────────────────────────────
export function ScreenHeader({ title, action }) {
  const { setOpen } = useDrawer();
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 'var(--gap-2)',
      padding: '14px var(--gap-3) 8px',
    }}>
      <IconButton className="mema-menu-btn" icon="menu" onClick={() => setOpen(true)} variant="surface" size={36} label="Menu"/>
      <div style={{ flex: 1, fontSize: 17, fontWeight: 600, letterSpacing: -0.3, color: 'var(--text-primary)' }}>{title}</div>
      {action}
    </div>
  );
}
